import axios from 'axios'
import { getToken, clearAuth } from './auth'
import { getEncontroSlug } from './encontro'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

api.interceptors.request.use(config => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  const slug = getEncontroSlug()
  if (slug) {
    config.headers['X-Encontro-Slug'] = slug
  }
  return config
})

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      clearAuth()
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default api
